import { useTranslation } from "react-i18next"
import { Activity } from "../../types"
import "./Timeline.css"
import { TimelineIcon } from "./TimelineIcon"
import { UserRow } from "../UserRow"
import { ConnectUser } from "../../api/ConnectApi"
import { formatDateAsConnect } from "../../util/dateTools"
import { getActivityDetails, getDescription } from "./util"
import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"

dayjs.extend(duration)

export interface TimelineCardProps {
  onSelect: (activity: Activity) => void
  active?: Activity // used to render "selected"
  activity: Activity
  connectProjectId: string
  users: { [key: string]: ConnectUser }
}

export const formatSecondsSpentText = (secondsSpent: number | undefined, t: any) => {
  if (!secondsSpent) return ""

  const duration = dayjs.duration(secondsSpent, "seconds")
  const days = duration.days()
  const hours = duration.hours()
  const minutes = duration.minutes()
  const seconds = duration.seconds()

  let result = `${t("main.duration")}`
  if (days > 0) result += `${days}${t("main.days")} `
  if (hours > 0) result += `${hours}${t("main.hours")} `
  if (minutes > 0) result += `${minutes}${t("main.minutes")} `
  if (seconds > 0) result += `${seconds}${t("main.seconds")} `

  return result.trim()
}

export const TimelineCard = ({
  onSelect,
  active,
  activity,
  activity: {
    type,
    time,
    // user: { id, name, organization }
    userId,
    secondsSpent
  },
  connectProjectId,
  users
}: TimelineCardProps) => {
  const activeClass = active === activity ? " active" : ""
  const onSelectActivity = () => onSelect(activity)
  const { t } = useTranslation(["timeline", "common"])
  return (
    <div className={`module activity-list mb-1 p-4 pointer${activeClass}`} onClick={onSelectActivity}>
      <div className="d-none d-md-flex activity-time">
        <p className="text-meta">{formatDateAsConnect(time)}</p>
      </div>
      <div className="d-none d-md-flex activity-time">
        <p className="text-meta">{formatSecondsSpentText(secondsSpent, t)}</p>
      </div>
      <div className="d-none d-md-flex activity-time">
        <p className="text-meta">{activity.isImplicit && t("main.implicit")}</p>
      </div>
      <div className="flex-row">
        <div className="d-none d-md-block activity-type">
          <TimelineIcon type={type} />
        </div>
        <div className="activity">
          <UserRow connectProjectId={connectProjectId} userId={userId} user={users[userId]} />
          <div className="mt-1">
            <p>
              {getActivityDetails(activity)}
              {getDescription(activity)}
            </p>
          </div>
        </div>
        {
          <div className="vertical-center">
            <i className="icon-font tc-icon-chevron-right"></i>
          </div>
        }
      </div>
    </div>
  )
}
